import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section className="py-24 px-6 bg-luxury-black text-white relative overflow-hidden" data-id="element-60">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-61">
        <div className="absolute top-[-20%] right-[-10%] w-96 h-96 bg-gold rounded-full filter blur-3xl" data-id="element-62"></div>
        <div className="absolute bottom-[-20%] left-[-10%] w-96 h-96 bg-gold rounded-full filter blur-3xl" data-id="element-63"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-65">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6" data-id="element-66">
            ELEVA TU IMAGEN PROFESIONAL HOY
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 font-sans font-light mb-10" data-id="element-67">
            Haz que cada cita refleje organización, lujo y profesionalismo.
          </p>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-gold hover:bg-gold-light text-luxury-black font-sans font-bold text-lg tracking-widest uppercase px-12 py-5 rounded-sm transition-colors duration-300 shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-68">
            ORDENAR MI KIT
          </motion.button>
        </motion.div>
      </div>
    </section>;
}